import {LatLon} from '../models/LatLon'

export abstract class Base {
  public config: any

  // Will be replaced with specific provider
  public map: any

  constructor(config: any, mapInstance: any) {
    this.config = config
    this.map = mapInstance
  }

  public abstract loadResources(): any[]

  public abstract initMap(element: HTMLElement, initConfig: any, s: () => void): void

  public abstract setClickListener(l: (p: LatLon) => void): void

  public abstract pan(p: LatLon): void

  public destroy(): void {
    // Implement
  }

  public cleanChild(c: any): void {
    console.log('cleanChild NOT IMPLEMENTED')
  }

  public addPolyline(points: LatLon[], lineWidth: number, color: string): void {
    console.log('addPolyline NOT IMPLEMENTED', this.constructor.name)
  }

  public addPolygon(points: LatLon[], lineWidth: number, color: string, popupElement: any, click: () => void): void {
    console.log('addPolygon NOT IMPLEMENTED', this.constructor.name)
  }

  public addMarker(point: LatLon, icon: string, popupElement: any, click: () => void): void {
    console.log('addPolyline NOT IMPLEMENTED', this.constructor.name)
  }

  public addCircle(point: LatLon, radius: number, popupElement: any, click: () => void) {
    console.log('addCircle NOT IMPLEMENTED', this.constructor.name)
  }

  public markerClusterLib(): any[] {
    return []
  }

  public markerCluster(item: any, child: any): void {
    console.log('addMarkerCluster NOT IMPLEMENTED', this.constructor.name)
  }

  public addHeatmap(points: LatLon[]): void {
    console.log('addHeatmap NOT IMPLEMENTED', this.constructor.name)
  }
}
